// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PMFHX","top":"styles_top__1VP4N","left":"styles_left__OH9CB","description":"styles_description__QD9mO"};